import { BaseEquipment, GymTypes } from 'fitbeat.models';
import { UserExerciseSession, WorkoutSettings } from '../../entities';

export function isHomeBoxingWorkout(
  userWorkoutSettings: WorkoutSettings,
  gymType: GymTypes,
): boolean {
  return userWorkoutSettings.allowBagContact
    && gymType === GymTypes.Home
    && BaseEquipment.isBodyweightOnly(userWorkoutSettings.equipment);
}

export function isBoxingWorkout(
  previousExerciseSessions?: UserExerciseSession[],
): boolean {
  if (!previousExerciseSessions) {
    return false;
  }
  if (previousExerciseSessions.length === 0) {
    return false;
  }

  return previousExerciseSessions[0].parentWorkoutSession.areaCategory === 'boxing';
}
